module.exports = __webpack_public_path__ + "static/media/browsers-icons.d01f52cd.png";